import React from "react";
import { companiesData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import highlight from "./highlight";
import "./homeRedesign.css";

const Recruiters = ({ data }) => {
  const { eyebrow, heading, logos, highlight: hl } = data || companiesData;
  const loop = [...logos, ...logos];

  return (
    <section className="recruiters-ed" aria-label="Our recruiters">
      <div className="container">
        <div className="section-head-ed section-head-ed--center">
          <span className="eyebrow-ed">{eyebrow}</span>
          <h2 className="heading-ed">{highlight(heading, hl)}</h2>
        </div>
      </div>

      <div className="recruiters-ed__marquee">
        <div className="recruiters-ed__track">
          {loop.map((src, i) => (
            <div className="recruiters-ed__logo" key={i}>
              <img src={mediaUrl(src)} alt="Recruiter logo" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recruiters;
